import Vue from 'vue';
import utility from '@/shared/utility';
import doRequest from '@/api/dssRequest';
import { translate } from '@/translation/native_translate';
import store from '../store';
import appConfig from '../../config/app_config';

/**
 * Main object to manage user login and set the relevant flags
 * in the store
 */
export default class UserObject {
  constructor(email = '') {
    this.email = email.trim();
    this.id = '';
  }

  userRegister(password, cs = null, ce = null) {
    const payload = UserObject._createRegisterRequestObject({
      email: this.email,
      password,
    });
    doRequest(
      (response) => {
        if (cs !== null) cs(response);
      },
      (error) => {
        if (ce !== null) ce(error);
      },
      'registerUser',
      `${store.getters['Account/partnerGroupDetails'].AccountId}_UM`,
      payload
    );
  }

  /**
   * the function takes case to store the uniqueId passed, request the getUserData and store
   * the returned values.
   * @param {string} password the password for login
   * @param {function} cs if passed, it will be called when the login is successfull
   * @param {function} ce if passed, it will be called when the login fails
   */
  userlogin(password, cs = null, ce = null) {
    const payload = {
      Email: this.email,
      Password: password,
      client_id: appConfig.Userlogin.clientId,
      client_secret: appConfig.Userlogin.clientSecret,
      grant_type: 'personal_token',
      scope: '*',
    };

    store.commit('auth/setToken', '');

    doRequest(
      (response) => {
        store.commit('auth/setUserName', response.data.UserId);
        store.commit('auth/setToken', response.data.AccessToken);
        store.commit('auth/setRefreshToken', response.data.RefreshToken);
        store.commit('auth/setUserLevel', response.data.UserLevel);
        store.commit(
          'auth/setUserEnv',
          store.getters['Account/partnerGroupDetails'].AccountId
        );

        if (response.data.UserLevel === 6 && response.data.PartnerId !== -1) {
          store.commit('auth/setPartnerId', response.data.PartnerId);
        } else {
          store.commit('auth/setPartnerId', -1);
        }

        this.getUserData(cs, ce);
      },
      (error) => {
        if (ce !== null && typeof ce === 'function') ce(error);
      },
      'login',
      appConfig.dss.accountManagerObjectId,
      payload
    );
  }

  getUserData(cs, ce) {
    doRequest(
      (response) => {
        UserObject.parsePartnerGroupUserRelations(response.data);
        this.parseUser(response.data);
        this.parseSubscriptions(response.data);
        this.parseUserRelationsAsChild(response.data);
        this.parseUserRelationsAsParent(response.data);
        // get the favourites of the user
        UserObject.getFavourites();
        // window.EventBus.fire('getShoppingLists');
        this.getShoppingCartData();

        if (cs !== null && typeof cs === 'function') cs(response);
      },
      (error) => {
        if (ce !== null && typeof ce === 'function') ce(error);
      },
      'getUserData',
      store.getters['auth/userName'],
      this.createGetUserDataRequest()
    );
  }

  applyPersonalDiscounts(reservations) {
    const payload = {
      Reservations: reservations,
    }
    return new Promise((resolve, reject) => {
      doRequest(
        resolve,
        reject,
        'applyPersonalDiscountsOnOrders',
        store.getters['auth/userName'],
        payload
      );
    });
  }
  getReservations(orderData) {
    var reservations = {};
      for (const order of orderData) {
        console.log("order", order)
       // if (order.ShoppingCartType === 'Product') {
          reservations[order.EventId] = [order.OrderId];
      //  }
      }
    return reservations;
  }
  getShoppingCartData() {
    const shoppingCart = store.getters['shoppingCart/orders'];
    if (shoppingCart !== null && shoppingCart.length > 0) {
      const reservations = this.getReservations(shoppingCart)
      if (reservations !== null) {
        this.applyPersonalDiscounts(reservations).then((response) => {
          if (response.data.Orders !== null && response.data.Orders.length >0 ) {
            console.log("ShoppingCart orders", response.data.Orders)
            store.commit('shoppingCart/refreshOrders', response.data.Orders);
          }
        });
      }
    }
  }
  parseUserRelationsAsChild(data) {
    store.commit('auth/setUserRelationsAsChild', {});
    let userRelationsAsChild = {};
    let shoppingList = [];
    if (
      data !== null &&
      data.hasOwnProperty('UserUserRelationsAsChild') &&
      data.UserUserRelationsAsChild.ShoppingLists != null
    ) {
      data.UserUserRelationsAsChild.ShoppingLists.forEach((list) => {
        let userData = {
          ChildEmailAddress: list.ChildEmailAddress,
          ChildUserId: list.ChildUserId,
          ParentEmailAddress: list.ParentEmailAddress,
          ParentUserId: list.ParentUserId,
          Type: list.Type,
        };
        shoppingList.push(userData);
      });
    }

    userRelationsAsChild = shoppingList;
    store.commit('auth/setUserRelationsAsChild', userRelationsAsChild);
    console.log('userRelationsAsChild', userRelationsAsChild);
  }
  parseUserRelationsAsParent(data) {
    store.commit('auth/setUserRelationsAsParent', {});
    let userRelationsAsParent = {};
    let shoppingList = [];
    if (
      data !== null &&
      data.hasOwnProperty('UserUserRelationsAsParent') &&
      data.UserUserRelationsAsParent.ShoppingLists != null
    ) {
      data.UserUserRelationsAsParent.ShoppingLists.forEach((list) => {
        let userData = {
          ChildEmailAddress: list.ChildEmailAddress,
          ChildUserId: list.ChildUserId,
          ParentEmailAddress: list.ParentEmailAddress,
          ParentUserId: list.ParentUserId,
          Type: list.Type,
        };
        shoppingList.push(userData);
      });
    }

    userRelationsAsParent = shoppingList;
    store.commit('auth/setUserRelationsAsParent', userRelationsAsParent);
    console.log('userRelationsAsParent', userRelationsAsParent);
  }

  parseSubscriptions(data) {
    store.commit('auth/setSubscriptions', []);
    const subscriptionsArray = [];
    data.SubScriptions.forEach((subscription) => {
      if (subscription.Segments != null) {
        subscription.Segments.forEach((segment) => {
          subscriptionsArray.push({
            ...segment,
            PrimaryColor: subscription.PrimaryColor,
            SecondaryColor: subscription.SecondaryColor,
            Logo: subscription.Logo,
          });
        });
      }
    });
    store.commit('auth/setSubscriptions', subscriptionsArray);
  }
  static parsePartnerGroupUserRelations(data) {
    store.commit('auth/setPartnerGroupUserRelations', []);
    const partnerGroupUserRelationsArray = [];
    if (data.PartnerGroupUserRelations != null) {
      data.PartnerGroupUserRelations.forEach((relation) => {
        partnerGroupUserRelationsArray.push({
          Email: relation.Email,
          PartnerGroupId: relation.PartnerGroupId,
          UserId: relation.UserId,
          WhatsappMessagingAllowed: relation.WhatsappMessagingAllowed,
          SMSMessagingAllowed: relation.SMSMessagingAllowed,
        });
      });
    }
    store.commit(
      'auth/setPartnerGroupUserRelations',
      partnerGroupUserRelationsArray
    );
  }

  parseUserData(data) {
    this.userData = utility.createArrayWithObjects(data.UserData.User);

    store.commit('auth/setUser', this.userData[0]);
  }

  parseUser(data) {
    store.commit('auth/setDutchStamps', data.DutchStamps);
    store.commit('auth/setUserCredits', data.UserCredits);
    store.commit('auth/setUserSegments', data.SubScriptions);
    store.commit('auth/setPartnerUserRelations', data.PartnerUserRelations);
    store.commit('setFrontEndType', data.FrontEndType);
    const object = utility.createArrayWithObjects(data.UserData.User)[0];

    this.email = object.Email;
    this.firstName = object.FirstName;
    this.lastName = object.LastName;
    this.street = object.Street;
    this.houseNo = object.Nr;
    this.city = object.City;
    this.postalCode = object.PostalCode;
    this.country = object.Country;
    this.countryCode = object.CountryCode;
    this.latitude = object.Latitude;
    this.longitude = object.Longitude;
    this.dob = object.DoB;
    this.picture = object.Picture;
    this.phoneNo = object.PhoneNumber;
    this.iban = object.IBAN;
    this.allowDirectDebit = object.AllowDirectDebit;
    this.accountHolderName = object.AccountHolderName;

    // For prof user
    this.professionalUser = object.ProfessionalUser;
    this.companyName = object.CompanyName;
    this.kvkNumber = object.KvKNumber;
    this.vatNumber = object.VATNumber;

    store.commit('auth/setUser', {});
    store.commit('auth/setUser', this);

    if (data.UserLanguage.LanguageTagId != null) {
      switch (data.UserLanguage.LanguageTagId) {
        case '13':
        case 13:
          store.commit('auth/setUserLanguage', {
            LanguageId: data.UserLanguage.LanguageTagId,
            EnglishName: 'English',
            LocalName: 'English',
          });
          return;
        case '14':
        case 14:
          store.commit('auth/setUserLanguage', {
            LanguageId: data.UserLanguage.LanguageTagId,
            EnglishName: 'Dutch',
            LocalName: 'Nederlands',
          });
          return;
        case '15':
        case 15:
          store.commit('auth/setUserLanguage', {
            LanguageId: data.UserLanguage.LanguageTagId,
            EnglishName: 'Italian',
            LocalName: 'Italiano',
          });
          return;
        case '16':
        case 16:
          store.commit('auth/setUserLanguage', {
            LanguageId: data.UserLanguage.LanguageTagId,
            EnglishName: 'French',
            LocalName: 'Français',
          });
          return;
        case '17':
        case 17:
          store.commit('auth/setUserLanguage', {
            LanguageId: data.UserLanguage.LanguageTagId,
            EnglishName: 'German',
            LocalName: 'Deutsch',
          });
          return;
        default:
          store.commit('auth/setUserLanguage', {
            LanguageId: data.UserLanguage.LanguageTagId,
            EnglishName: 'English',
            LocalName: 'English',
          });
      }
    }
  }

  /**
   * it creates the getUserData payload
   */
  createGetUserDataRequest() {
    const requestObject = {
      RelationType: 'User',
      Id: store.getters['auth/userName'],
      Types: {
        User: 'User',
      },
    };
    return requestObject;
  }

  static _createRegisterRequest(object) {
    const requestObject = {
      UserFirstName: object.userFirstname,
      UserLastName: object.userLastName,
      SubType: '1',
      UserTags: [],
      FrontEndType: 'WEB',
    };
    const N = object.userTags.length;
    for (let e = 0; e < N; e++) {
      requestObject.UserTags[e] = object.userTags[e];
    }

    const json = JSON.stringfy(requestObject);

    return json;
  }

  static _createActivateUserObject(id, email, userId, token, partnerId) {
    const requestObject = {
      client_id: id,
      Email: email,
      UserId: userId,
      Token: token,
    };

    if (partnerId !== undefined) {
      requestObject.PartnerId = Number(partnerId);
    }

    return requestObject;
  }

  static getUserDataStatic(cs, ce) {
    doRequest(
      (response) => {
        const userObject = utility.createArrayWithObjects(
          response.data.UserData.User
        )[0];
        this.userData = {
          city: userObject.City,
          country: userObject.Country,
          countryCode: userObject.CountryCode,
          dob: userObject.Dob,
          email: userObject.Email,
          firstName: userObject.FirstName,
          houseNo: '',
          lastName: userObject.LastName,
          id: userObject.Id,
          phoneNo: userObject.phoneNo,
          picture: '',
          postalCode: userObject.postalCode,
          street: userObject.Street,
          latitude: userObject.latitude,
          longitude: userObject.longitude,
        };

        store.commit('auth/setUser', this.userData);

        if (response.data.UserLanguage.LanguageTagId !== undefined) {
          store.commit(
            'auth/setUserLanguage',
            response.data.UserLanguage.LanguageTagId
          );
        }
        if (cs !== null && typeof cs === 'function') cs(response);
      },
      (error) => {
        if (ce !== null && typeof ce === 'function') ce(error);
      },
      'getUserData',
      store.getters['auth/userName'],
      {
        RelationType: 'User',
        Id: store.getters['auth/userName'],
        Types: {
          User: 'User',
        },
      }
    );
  }

  static _createRegisterRequestObject(object) {
    if (
      store.getters.getRedirectedFromPearlCalendar &&
      store.getters.getSavePartnerId !== ''
    ) {
      this.requestObject = {
        client_id: 'MoXA5aY6gNyahQ9SMntzJ3Adj8BLyhuDSgVW1ft9',
        Email: object.email,
        Password: object.password,
        RegisteredFrom: 'WEB',
        PartnerId: Number(store.getters.getSavePartnerId),
      };
    } else {
      this.requestObject = {
        client_id: 'MoXA5aY6gNyahQ9SMntzJ3Adj8BLyhuDSgVW1ft9',
        Email: object.email,
        Password: object.password,
        RegisteredFrom: 'WEB',
      };
    }

    return this.requestObject;
  }

  static updateUser(object, callbackSuccess, callbackError) {
    const payload = {
      Email: object.email,
      FirstName: object.firstName,
      LastName: object.lastName,
      DoB: object.dob,
      City: object.city,
      PostalCode: object.postalCode,
      Street: object.street,
      Nr: object.houseNo,
      Country: object.country,
      CountryCode: object.countryCode,
      PhoneNumber: object.phoneNo,
      Picture: object.picture,
      IBAN: object.iban,
      AccountHolderName: object.accountHolderName,
      AllowDirectDebit: object.allowDirectDebit,
      Longitude: object.longitude,
      Latitude: object.latitude,
      ProfessionalUser: object.professionalUser,
      CompanyName: object.companyName,
      KvKNumber: object.kvkNumber,
      VATNumber: object.vatNumber,
    };
    payload.FunctionId = 'UserFunctionLibrary::updateUser';

    doRequest(
      () => {
        if (callbackSuccess !== null && typeof callbackSuccess === 'function')
          callbackSuccess();
          window.EventBus.fire(
            'activateSnackBar',
            translate('SUCCESS_SAVING_SETTINGS')
          );
      },
      () => {
        if (callbackError !== null && typeof callbackError === 'function' && ErrorCode=== "E_PHONE_003")
          callbackError();
          window.EventBus.fire('activateSnackBar', {
            text: translate('FAILED_SAVING_PHONENUMBER_SETTINGS'),
            color: 'error',
          });
      },
      'updateUser',
      store.getters['auth/userName'],
      payload
    );
  }

  /**
   * it creates an edit user request to use for
   * saveUserData
   * @param {object} object
   */
  static _createEditRequestObject(object) {
    console.log('_createEditRequestObject', object);
    const req = {
      Tags: object.tags,
      FirstName: object.FirstName,
      LastName: object.LastName,
      Email: object.Email,
      PhoneNumber: object.PhoneNumber,
      PostalCode: object.PostalCode,
      Country: object.Country,
      CountryCode: object.CountryCode,
      LicensePlate: object.LicensePlate,
      Latitude: object.Latitude,
      Longitude: object.Longitude,
    };

    req.UserIndex = Number(req.UserIndex);
    req.dob = Number(req.dob);
    req.last_active_timestamp = Number(req.last_active_timestamp);
    req.UserId = object.name;

    return req;
  }

  // Get user favourites and save in store
  static getFavourites() {
    const userId = store.getters['auth/userName'];

    if (userId == null || userId === '') {
      return Promise.reject(new Error('INVALID_USER_ID'));
    }

    const payload = {};

    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          if (response.data.FavouriteMap != null) {
            store.commit('user/setFavourites', response.data.FavouriteMap);
          }

          resolve(response);
        },
        (error) => {
          reject(error);
        },
        'getFavourites',
        userId,
        payload
      );
    });
  }

  /**
   * @brief Add item to user's favourite list
   * @param {String} id Id of the favourite item
   * @param {String} type Type of the favourite item, i.e. Product, Event, ProductCategory
   */
  static addFavourite(id, type) {
    const userId = store.getters['auth/userName'];

    if (userId == null || userId === '') {
      return Promise.reject(new Error('INVALID_USER_ID'));
    }

    const payload = {
      ObjectId: id,
      ObjectType: type,
    };

    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          // Reload favourites
          UserObject.getFavourites();

          window.EventBus.fire(
            'activateSnackBar',
            translate('ADDED_TO_FAV_GENERIC')
          );

          resolve(response);
        },
        (error) => {
          reject(error);
        },
        'addFavourite',
        userId,
        payload
      );
    });
  }

  /**
   * @brief Delete item from user's favourite list
   * @param {String} id Id of the favourite item
   * @param {String} type Type of the favourite item, i.e. Product, Event, ProductCategory
   */
  static deleteFavourite(id, type) {
    const userId = store.getters['auth/userName'];

    if (userId == null || userId === '') {
      return Promise.reject(new Error('INVALID_USER_ID'));
    }

    const payload = {
      ObjectId: id,
      ObjectType: type,
    };

    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          // Reload favourites
          UserObject.getFavourites();

          window.EventBus.fire(
            'activateSnackBar',
            translate('DELETED_FROM_FAV_GENERIC')
          );

          resolve(response);
        },
        (error) => {
          reject(error);
        },
        'deleteFavourite',
        userId,
        payload
      );
    });
  }

  /**
   * @returns {String} Real or temp user id
   */
  static getUserObjectId() {
    const userLoggedIn = store.getters['auth/isValid'];
    if (userLoggedIn) {
      return store.getters['auth/userName'];
    }
    return store.getters['auth/tmpUserId'];
  }

  /**
   * Log user out from all entries (local, Google, Facebook)
   * clear shopping cart and user info in store
   */
  static logout() {
    // Clear shoppingCart if it's not empty
    const orders = store.getters['shoppingCart/orders'];
    if (orders.length > 0) {
      let item = {};
      orders.forEach((order) => {
        // If type is product, call removeProduct() to remove item from shoppingCart
        if (order.ShoppingCartType === 'Product') {
          order.Products.forEach((productItem) => {
            item = {
              itemId: productItem.ItemId,
              orderIndex: orders.indexOf(order),
            };
            store.commit('shoppingCart/removeOrder', item);
          });
        } else if (order.ShoppingCartType === 'Ticket') {
          order.PriceCategories.forEach((ticket) => {
            item = {
              itemId: ticket.OrderItemId,
              orderIndex: orders.indexOf(order),
            };
            store.commit('shoppingCart/removeOrder', item);
          });
        }
      });
    }

    // Clear shopping lists
    store.commit('shoppingList/setOrders', []);

    // Clear favourites
    store.commit('user/setFavourites', []);

    // Clear front end type for customized home page
    store.commit('setFrontEndType', '');

    // Google sign out
    Vue.GoogleAuth.then((auth2) => {
      if (auth2.isSignedIn.get()) {
        auth2.signOut();
      }
    });

    // Facebook sign out
    if (window.FB != null) {
      window.FB.getLoginStatus((response) => {
        if (response.status === 'connected') {
          window.FB.logout();
        }
      });
    }

    // Clear user in store
    store.dispatch('auth/logout');

    //Set tempUserId
    store.commit('auth/setTmpUserId', this.makeTmpUserId(16));
  }

  static makeTmpUserId(length) {
    const randomStr = utility.getRandomString(
      length,
      true,
      true,
      true,
      false
    );
    return `TMP_${randomStr}`;
  }

  /**
   * Get all product categories visible to the user
   * @returns
   */
  static getProductCategories() {
    const userObjectId = store.getters['auth/userObjectId'];

    if (userObjectId == null || userObjectId.trim() === '') {
      return Promise.reject(new Error('INVALID_USER_ID'));
    }

    const payload = {
      UseGenericResponse: false,
    };

    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          let categoryList = [];
          if (response.data.ProductCategories != null) {
            categoryList = response.data.ProductCategories;
          }
          store.commit('user/setProductCategories', categoryList);
          resolve(categoryList);
        },
        (error) => {
          reject(error);
        },
        'getProductCategories',
        userObjectId,
        payload,
        'GET'
      );
    });
  }

  /**
   * Get all product categories with products
   * @returns
   */
  static getProductCategoriesWithProducts() {
    const userObjectId = store.getters['auth/userObjectId'];

    if (userObjectId == null || userObjectId.trim() === '') {
      return Promise.reject(new Error('INVALID_USER_ID'));
    }

    const payload = {
      UseGenericResponse: false,
      UnrollSubCategories: false, // for subcategories
    };
    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          let productCategoriesWithProducts = [];
          if (response.data.ProductCategories != null) {
            productCategoriesWithProducts = response.data.ProductCategories;
          }
          store.commit(
            'user/setProductCategoriesWithProducts',
            productCategoriesWithProducts
          );
          resolve(productCategoriesWithProducts);
        },
        (error) => {
          reject(error);
        },
        'getProductCategoriesWithProducts',
        userObjectId,
        payload,
        'GET'
      );
    });
  }
  /**
   * Get all product categories visible to the user
   * @returns
   */
  static getPromotions() {
    const userObjectId = store.getters['auth/userObjectId'];

    if (userObjectId == null || userObjectId.trim() === '') {
      return Promise.reject(new Error('INVALID_USER_ID'));
    }

    const payload = {};

    store.commit('user/setLoadingPromotions', true);

    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          let promotions = [];
          if (response.data.Promotions != null) {
            promotions = response.data.Promotions;
          }
          store.commit('user/setPromotions', promotions);

          let blogs = [];
          if (response.data.BlogEvents != null) {
            blogs = response.data.BlogEvents;
          }
          store.commit('user/setBlogs', blogs);

          store.commit('user/setLoadingPromotions', false);

          resolve(response);
        },
        (error) => {
          store.commit('user/setPromotions', []);
          store.commit('user/setBlogs', []);
          store.commit('user/setLoadingPromotions', false);

          reject(error);
        },
        'getPromotions',
        userObjectId,
        payload,
        'GET'
      );
    });
  }

  /**
   * Get all messages for the user
   * @returns
   */
  static getMessagesForUser() {
    const userObjectId = store.getters['auth/userObjectId'];

    if (userObjectId == null || userObjectId.trim() === '') {
      return Promise.reject(new Error('INVALID_USER_ID'));
    }

    // const mainPartner = store.getters['Account/mainPartner'];

    const payload = {};

    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          let msgList = [];
          if (response.data.Messages != null) {
            msgList = response.data.Messages;
          }
          store.commit('userChats/setChats', msgList);
          resolve(msgList);
        },
        (error) => {
          reject(error);
        },
        'getMessagesForUser',
        'LocationsNode_MSE',
        payload
      );
    });
  }

  /**
   * Get all messages for the user
   * @returns
   */
  static markMessagesAsRead(partnerObjId) {
    const payload = {};

    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          let msgList = [];
          if (response.data.Messages != null) {
            msgList = response.data.Messages;
          }
          store.commit('userChats/setMessages', msgList);
          resolve(msgList);
        },
        (error) => {
          reject(error);
        },
        'markMessageAsRead',
        partnerObjId,
        payload
      );
    });
  }

  static requestWhatsappOptIn() {
    const userObjectId = store.getters['auth/userObjectId'];

    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          window.EventBus.fire('activateSnackBar', {
            text: translate('WHATSAPP_REQUEST_SUCCESS'),
            color: 'success',
          });
          resolve(response);
        },
        (error) => {
          window.EventBus.fire('activateSnackBar', {
            text: translate('WHATSAPP_REQUEST_FAILED'),
            color: 'error',
          });
          reject(error);
        },
        'requestWhatsappOptIn',
        userObjectId,
        {}
      );
    });
  }
  static whatsappOptOut() {
    const userObjectId = store.getters['auth/userObjectId'];

    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          window.EventBus.fire('activateSnackBar', {
            text: translate('WHATSAPP_OPT_OUT_SUCCESS'),
            color: 'success',
          });
          resolve(response);
        },
        (error) => {
          window.EventBus.fire('activateSnackBar', {
            text: translate('WHATSAPP_OPT_OUT_FAILED'),
            color: 'error',
          });
          reject(error);
        },
        'whatsappOptOut',
        userObjectId,
        {}
      );
    });
  }
  static requestSMSOptIn() {
    const userObjectId = store.getters['auth/userObjectId'];

    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          window.EventBus.fire('activateSnackBar', {
            text: translate('SMS_REQUEST_SUCCESS'),
            color: 'success',
          });
          resolve(response);
        },
        (error) => {
          window.EventBus.fire('activateSnackBar', {
            text: translate('SMS_REQUEST_FAILED'),
            color: 'error',
          });
          reject(error);
        },
        'smsOptIn',
        store.getters['auth/userName'],
        {}
      );
    });
  }
  static SMSOptOut() {
    const userObjectId = store.getters['auth/userObjectId'];

    return new Promise((resolve, reject) => {
      doRequest(
        (response) => {
          window.EventBus.fire('activateSnackBar', {
            text: translate('SMS_OPT_OUT_SUCCESS'),
            color: 'success',
          });
          resolve(response);
        },
        (error) => {
          window.EventBus.fire('activateSnackBar', {
            text: translate('SMS_OPT_OUT_FAILED'),
            color: 'error',
          });
          reject(error);
        },
        'smsOptOut',
        store.getters['auth/userName'],
        {}
      );
    });
  }
}
